import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Box,
  Typography,
  useTheme,
  Grid,
  Paper,
  Stack,
  Divider,
  Skeleton,
  Chip,
  LinearProgress,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import DrawerWrapper from "../../../components/drawer/Drawer";
import AgGridTable from "../../../components/table/AgGridTable";
import Exclamation from "../../../assets/Exclamation.png";
import { useNavigate } from "react-router-dom";
import Critical_Dashboard_img from "../../../assets/baseVersion/Critical_Dashboard_img.svg";
import High_Dashboard_img from "../../../assets/baseVersion/High_Dashboard_img.svg";
import Medium_Dashboard_img from "../../../assets/baseVersion/Medium_Dashboard_img.svg";
import Low_Dashboard_img from "../../../assets/baseVersion/Low_Dashboard_img.svg";
import eventEmitter from "../../../components/utils/eventEmitter";
import LaunchSharpIcon from "@mui/icons-material/LaunchSharp";
import { setSelectedRowID } from "../../../pages/SecurityPosture/TabSelection-slice";
import { useDispatch, useSelector } from "react-redux";
import SecurityDetailsDrawer from "../../../pages/SecurityPosture/SecurityDetailsDrawer";
import { useStorageManager } from "../../../shared/hooks";
import ReactECharts from "echarts-for-react";
import { RootState } from "../../../store/store";
import styles from "../IntelliScore/intelliscore.module.scss";
import AcceptedRisk_False from "../../../assets/baseVersion/AcceptedRisk_False.svg";
import { useDashboardContext } from "../DashboardContext";

declare global {
  interface Window {
    ApexCharts?: any;
  }
}

// Define interfaces for API response
interface Vulnerability {
  vulnerabilities_name: string;
  percentage: number;
  count: number;
}

interface VulnerabilityData {
  vulnerabilities: Vulnerability[];
  total_count: number;
}

interface MisconfigurationResponse {
  status: number;
  message: string;
  data: {
    misconfigurations: {
      on_premise: VulnerabilityData;
      cloud: VulnerabilityData;
    };
  };
}

interface ChartData {
  id: string;
  title: string;
  gaugeValue: number;
  breakdown: {
    label: string;
    value: string;
    percentage: string;
    color: string;
  }[];
}

// Color mapping for vulnerability levels
const vulnerabilityColors = {
  Critical: "#960000",
  High: "#E82F00",
  Medium: "#FFA500",
  Low: "#FFD700",
};

// Define a specific order for severities
const severityOrder = ["Critical", "High", "Medium", "Low"];

const Misconfiguration: React.FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const hasLoadedRef = useRef(false);
  //const [chartData, setChartData] = useState<ChartData[]>([]);
  const [onPremChartData, setOnPremChartData] = useState<ChartData | null>(
    null
  );
  const [cloudChartData, setCloudChartData] = useState<ChartData | null>(null);
  const [selectedModule, setSelectedModule] = useState<string>("");
  const [selectedSeverity, setSelectedSeverity] = useState<string>("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [riskDetails, setRiskDetails] = React.useState<any[]>([]);
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const [trigger, setTrigger] = useState(0);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const { setIsOverlayOpen } = useDashboardContext();

  // Notify parent context when drawer opens/closes to disable drag and drop
  useEffect(() => {
    setIsOverlayOpen(isDrawerOpen || isDetailsDrawerOpen);
  }, [isDrawerOpen, isDetailsDrawerOpen, setIsOverlayOpen]);
  const [headerResponse, setHeaderResponse] = useState<any>(null);
  const [isCreateTag, setIsCreateTag] = useState<{
    default?: string[];
    user?: string[];
  }>({});
  const [totalResources, setTotalResources] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [isCreateTagClicked, setIsCreateTagClicked] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  const [value, setValue] = useState(0);
  const { getFromLocalStorage } = useStorageManager();
  const [isNewUserDetails, setIsNewUserDetails] = useState<any>(null);
  //const [isNewUserTrue, setIsNewUserTrue] = useState(false);
  const isNewUserTrue = useSelector(
    (state: RootState) => state.UserLoginDetails.isNewUserTrue
  );
  const isOnlyCloudUser = useSelector(
    (state: RootState) => state.UserLoginDetails.isOnlyCloudUser
  );
  const isOnlyPremAssetUser = useSelector(
    (state: RootState) => state.UserLoginDetails.isOnlyPremAssetUser
  );
  const isBothCloudAndPremAssetUser = useSelector(
    (state: RootState) => state.UserLoginDetails.isBothCloudAndPremAssetUser
  );

  console.log(isOnlyPremAssetUser, "isOnlyPremAssetUser");
  console.log(isOnlyCloudUser, "isOnlyCloudUser");
  console.log(isNewUserTrue, "isNewUserTrue");
  console.log(isBothCloudAndPremAssetUser, "isBothCloudAndPremAssetUser");
  // const [isOnlyCloudUser, setIsOnlyCloudUser] = useState(false);
  // const [isOnlyPremAssetUser, setIsOnlyPremAssetUser] = useState(false);
  // const [isbothCloudAndPremAssetUser, setIsBothCloudAndPremAssetUser] =
  //   useState(false);

  // Add chart rendering state
  const [chartReady, setChartReady] = useState(false);
  const [chartKey, setChartKey] = useState(0);
  const chartContainerRef = useRef<HTMLDivElement>(null);
  const resizeObserverRef = useRef<ResizeObserver | null>(null);
  const layoutStableTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const intersectionObserverRef = useRef<IntersectionObserver | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const isRenderingRef = useRef(false); // Prevent infinite loops
  const lastRenderTimeRef = useRef(0); // Track last render time

  // Add chart refs
  const chartRef1 = useRef<ReactECharts | null>(null);
  const chartRef2 = useRef<ReactECharts | null>(null);
  const chartRef3 = useRef<ReactECharts | null>(null);

  // useEffect(() => {
  //   const stored = getFromLocalStorage("isNewUserDetails");
  //   let parsed = null;
  //   try {
  //     parsed = stored ? JSON.parse(stored) : null;
  //   } catch (e) {
  //     parsed = null;
  //   }
  //   setIsNewUserDetails(parsed);
  //   if (parsed.device_count == 0 && parsed.cloud_count == 0) {
  //     setIsNewUserTrue(true);
  //   } else if (parsed.cloud_count > 0 && parsed.device_count == 0) {
  //     setIsOnlyCloudUser(true);
  //   } else if (parsed.device_count > 0 && parsed.cloud_count == 0) {
  //     console.log("isNewUserDetails from localStorage:", parsed);
  //     console.log("isOnlyPremAssetUser", isOnlyPremAssetUser);
  //     setIsOnlyPremAssetUser(true);
  //   } else {
  //     setIsBothCloudAndPremAssetUser(true);
  //   }
  //   console.log("isNewUserDetails from localStorage:", parsed);
  // }, []);

  const riskDetail = async (module: string) => {
    const moduleValue1 = selectedModule === "On-prem" ? "on_premise" : "cloud";
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(
        END_POINTS.RISK_ACCEPTANCE_TABLE,
        {
          params: {
            module: module,
          },
        }
      );
      setRiskDetails(response.data.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Risk Details Data Fetch Failed", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleFilterSaved = () => {
      hasLoadedRef.current = false; 
      setIsLoading(true); 
      setTrigger((prev) => prev + 1); // Changing this will re-trigger the effect
    };

    eventEmitter.on("filterSaved", handleFilterSaved);

    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
    };
  }, []);

  // useEffect(() => {
  //   const fetchUserDetails = async () => {
  //     //setIsUserTypeLoading(true);
  //     let parsed = null;
  //     const res = await axiosInstance.get(END_POINTS.IS_NEW_USER);
  //     console.log("isNewUserDetails from API:", res?.data?.data);
  //     if (res.status === 200) {
  //       const isNewUser = res?.data?.data || false;

  //       //saveToLocalStorage("isNewUserDetails", isNewUser);
  //       parsed = res?.data?.data || false;
  //     }

  //     if (parsed.device_count == 0 && parsed.cloud_count == 0) {
  //       setIsNewUserTrue(true);
  //     } else if (parsed.cloud_count > 0 && parsed.device_count == 0) {
  //       setIsOnlyCloudUser(true);
  //     } else if (parsed.device_count > 0 && parsed.cloud_count == 0) {
  //       console.log("isNewUserDetails from localStorage:", parsed);
  //       console.log("isOnlyPremAssetUser", isOnlyPremAssetUser);
  //       setIsOnlyPremAssetUser(true);
  //     } else {
  //       console.log("isbothCloudAndPremAssetUser", isbothCloudAndPremAssetUser);
  //       setIsBothCloudAndPremAssetUser(true);
  //     }
  //     console.log("isNewUserDetails from localStorage:", parsed);
  //     //setIsUserTypeLoading(false);
  //   };

  //   fetchUserDetails();
  //   //fetchAssetsData();
  // }, [trigger]);

  useEffect(() => {
    if (isDrawerOpen && selectedModule) {
      const moduleValue = selectedModule === "On-prem" ? "on_premise" : "cloud";
      riskDetail(moduleValue);
    }
  }, [isDrawerOpen, selectedModule, selectedSeverity, trigger]);

  useEffect(() => {
    const fetchMisconfigData = async (retryCount = 0) => {
      setLoading(true);
      //setChartReady(false); // Reset chart ready state
      try {
        // Calls DASHBOARD_MISCONFIGURATION ('securityscan/dashboard-overall-vulnerabilities') via GET (1st call) to fetch misconfigurations
        const response = await axiosInstance.get<MisconfigurationResponse>(
          END_POINTS.DASHBOARD_MISCONFIGURATION
        );
        const { misconfigurations } = response.data.data;

        // const transformedData: ChartData[] = [
        //   ...(isbothCloudAndPremAssetUser || isOnlyPremAssetUser
        //     ? [
        //         // Only include On-prem data if the user has on-prem assets
        //         {
        //           id: "on-prem",
        //           title: "On-prem",
        //           gaugeValue: misconfigurations.on_premise.total_count,
        //           breakdown: misconfigurations.on_premise.vulnerabilities.map(
        //             (vuln) => ({
        //               label: vuln.vulnerabilities_name,
        //               value: vuln.count.toString(),
        //               percentage: `${vuln.percentage}%`,
        //               color:
        //                 vulnerabilityColors[
        //                   vuln.vulnerabilities_name as keyof typeof vulnerabilityColors
        //                 ],
        //             })
        //           ),
        //         },
        //       ]
        //     : []),

        //   ...(isbothCloudAndPremAssetUser || isOnlyCloudUser
        //     ? [
        //         // Only include Cloud data if the user has cloud assets
        //         {
        //           id: "cloud",
        //           title: "Cloud",
        //           gaugeValue: misconfigurations.cloud.total_count,
        //           breakdown: misconfigurations.cloud.vulnerabilities.map(
        //             (vuln) => ({
        //               label: vuln.vulnerabilities_name,
        //               value: vuln.count.toString(),
        //               percentage: `${vuln.percentage}%`,
        //               color:
        //                 vulnerabilityColors[
        //                   vuln.vulnerabilities_name as keyof typeof vulnerabilityColors
        //                 ],
        //             })
        //           ),
        //         },
        //       ]
        //     : []),
        // ];

        // setChartData(transformedData);

        // Set chart ready after a delay to ensure layout is stable

        if (isBothCloudAndPremAssetUser || isOnlyPremAssetUser) {
          setOnPremChartData({
            id: "on-prem",
            title: "On-prem",
            gaugeValue: misconfigurations.on_premise.total_count,
            breakdown: misconfigurations.on_premise.vulnerabilities.map(
              (vuln) => ({
                label: vuln.vulnerabilities_name,
                value: vuln.count.toString(),
                percentage: `${vuln.percentage}%`,
                color:
                  vulnerabilityColors[
                    vuln.vulnerabilities_name as keyof typeof vulnerabilityColors
                  ],
              })
            ),
          });
        }

        if (isBothCloudAndPremAssetUser || isOnlyCloudUser) {
          setCloudChartData({
            id: "cloud",
            title: "Cloud",
            gaugeValue: misconfigurations.cloud.total_count,
            breakdown: misconfigurations.cloud.vulnerabilities.map((vuln) => ({
              label: vuln.vulnerabilities_name,
              value: vuln.count.toString(),
              percentage: `${vuln.percentage}%`,
              color:
                vulnerabilityColors[
                  vuln.vulnerabilities_name as keyof typeof vulnerabilityColors
                ],
            })),
          });
        }
      } catch (error) {
        console.error("Error fetching misconfiguration data:", error);
        //setChartData([]); // Reset data on error
        //setChartReady(false);

        // Retry logic - retry up to 2 times with exponential backoff
        if (retryCount < 2) {
          const delay = Math.pow(2, retryCount) * 1000; // 1s, 2s
          setTimeout(() => {
            fetchMisconfigData(retryCount + 1);
          }, delay);
        }
      } finally {
        setLoading(false);
        hasLoadedRef.current = true; // ensure subsequent rerenders don't show skeleton
      }
    };

    fetchMisconfigData();
  }, [
    trigger,
    isBothCloudAndPremAssetUser,
    isOnlyPremAssetUser,
    isOnlyCloudUser,
  ]);

  // Add effect to handle layout changes and resize
  useEffect(() => {
    if (!chartContainerRef.current || !chartReady) return;

    // Prevent infinite loops
    const canRender = () => {
      const now = Date.now();
      if (isRenderingRef.current || now - lastRenderTimeRef.current < 1000) {
        return false;
      }
      isRenderingRef.current = true;
      lastRenderTimeRef.current = now;
      return true;
    };

    const safeRender = () => {
      if (canRender()) {
        console.log("Safely re-rendering chart");
        setChartKey((prev) => prev + 1);
        setTimeout(() => {
          isRenderingRef.current = false;
        }, 100);
      }
    };

    // Create Intersection Observer to detect when chart becomes visible
    intersectionObserverRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            console.log("Chart container became visible");
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      }
    );

    intersectionObserverRef.current.observe(chartContainerRef.current);

    // Create ResizeObserver to detect container size changes
    resizeObserverRef.current = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (layoutStableTimeoutRef.current) {
          clearTimeout(layoutStableTimeoutRef.current);
        }

        layoutStableTimeoutRef.current = setTimeout(() => {
          console.log("Container resized, safely re-rendering");
          safeRender();
        }, 500);
      }
    });

    resizeObserverRef.current.observe(chartContainerRef.current);

    // Listen for window resize events
    const handleWindowResize = () => {
      if (layoutStableTimeoutRef.current) {
        clearTimeout(layoutStableTimeoutRef.current);
      }

      layoutStableTimeoutRef.current = setTimeout(() => {
        console.log("Window resized, safely re-rendering");
        safeRender();
      }, 500);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      if (intersectionObserverRef.current) {
        intersectionObserverRef.current.disconnect();
      }
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
      if (layoutStableTimeoutRef.current) {
        clearTimeout(layoutStableTimeoutRef.current);
      }
      window.removeEventListener("resize", handleWindowResize);
      isRenderingRef.current = false;
    };
  }, [chartReady]);

  // Add effect to handle theme changes
  // useEffect(() => {
  //   if (chartReady && chartData.length > 0 && isVisible) {
  //     // Only re-render when theme changes and chart is visible
  //     const now = Date.now();
  //     if (now - lastRenderTimeRef.current > 1000) {
  //       console.log("Theme changed, re-rendering chart");
  //       setChartKey(prev => prev + 1);
  //       lastRenderTimeRef.current = now;
  //     }
  //   }
  // }, [theme.palette.mode, chartReady, chartData.length, isVisible]);

  // Add cleanup effect for component unmounting
  useEffect(() => {
    let isMounted = true;

    return () => {
      // Cleanup when component unmounts
      isMounted = false;
      //setChartReady(false);
      //setChartData([]);

      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
      if (layoutStableTimeoutRef.current) {
        clearTimeout(layoutStableTimeoutRef.current);
      }
    };
  }, []);

  // Add effect to handle responsive resizing for ReactECharts
  useEffect(() => {
    const handleResize = () => {
      chartRef1.current?.getEchartsInstance().resize();
      chartRef2.current?.getEchartsInstance().resize();
      chartRef3.current?.getEchartsInstance().resize();
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  console.log("selectedModule", selectedModule);
  // console.log("Misconfiguration chart state:", {
  //   loading,
  //   chartReady,
  //   chartDataLength: chartData.length,
  //   isVisible
  // });

  // Filter riskDetails based on selectedSeverity
  const filteredRiskDetails = selectedSeverity
    ? riskDetails.filter((item) => (item.highest_priority === selectedSeverity)&&item.failed_asset_count>0)
    : riskDetails;

  const handleOnRowClick = (row: any) => {
    const moduleValue1 = selectedModule === "On-prem" ? "on_premise" : "cloud";
    setSelectedRow(row);
    setIsDetailsDrawerOpen(true);
    dispatch(setSelectedRowID(row.id));

    // Fetch header details
    axiosInstance
      .get(`securityscan/control-details/${row.id}`)
      .then((response) => {
        setHeaderResponse(response.data?.data);
        setIsCreateTag(response.data?.data?.tags);
      })
      .catch((error) => console.error("Error fetching details:", error));

    // Fetch total resources using selectedModule
    axiosInstance
      .get(
        `securityscan/control-asset-details/${row.id}?module=${
          moduleValue1 || "on_premise"
        }`
      )
      .then((response) => setTotalResources(response.data?.data))
      .catch((error) =>
        console.error("Error fetching total resources:", error)
      );
  };

  const allTags = [
    ...(isCreateTag?.default || []),
    ...(isCreateTag?.user || []),
  ];
  const visibleTags = allTags.slice(0, 3);
  const hiddenTags = allTags.slice(3);

  const getStyledTag = (tag: string, index: number) => (
    <Chip
      key={index}
      label={tag}
      style={{ borderRadius: 1, fontWeight: "bold" }}
      size="small"
    />
  );

  const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => {
    setAnchorEl(null);
    setIsCreateTagClicked(false);
  };
  const openPopover = Boolean(anchorEl);
  const id = openPopover ? "simple-popover" : undefined;

  const getSeverityStyle = (severity: string) => {
    switch (severity?.toLowerCase()) {
      case "low":
        return { color: "#F2BF00", backgroundColor: "#F2BF0024" };
      case "high":
        return { color: "#A7000F", backgroundColor: "#A7000F24" };
      case "critical":
        return { color: "#670004", backgroundColor: "#67000424" };
      case "medium":
        return { color: "#E85800", backgroundColor: "#E8580024" };
      default:
        return { color: "gray", backgroundColor: "#E0E0E0" };
    }
  };
  const Chipstyle = getSeverityStyle(headerResponse?.severity);

  const TypeChipColor = (type: string) => {
    switch (type) {
      case "Manual":
        return { color: "#2B335F", bgcolor: "#DEDDF2" };
      case "Automated":
        return { color: "#0B3D2E", bgcolor: "#CFF3E0" };
      default:
        return { color: "#000", bgcolor: "#E0E0E0" };
    }
  };

  if (loading && !hasLoadedRef.current) {
    if (isBothCloudAndPremAssetUser) {
      return (
        <Box height="100%" sx={{ p: 0, m: 0 }}>
          <Paper
            elevation={0}
            sx={{
              p: 0,
              pt: 0,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              bgcolor:
                theme.palette.mode === "dark" ? "background.paper" : "white",
              borderRadius: "4px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                height: "32px",
                mt: 1,
                ml: 1,
              }}
            >
              <Skeleton variant="text" width={150} height={24} />
            </Box>
            <Divider sx={{ mt: 0, mb: 0 }} />
            <Grid
              container
              spacing={0}
              alignItems="stretch"
              sx={{ flexGrow: 1, mt: 0, mb: 0, py: 0 }}
            >
              {[1, 2].map((index) => (
                <Grid item xs={12} md={6} key={index} sx={{ height: "auto" }}>
                  <Box
                    sx={{
                      p: 1,
                      height: "100%",
                      position: "relative",
                      borderLeft:
                        index === 2
                          ? `1px solid ${theme.palette.divider}`
                          : "none",
                    }}
                  >
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      sx={{ height: "100%" }}
                    >
                      <Grid item xs={6}>
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            height: "220px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {/* Semicircular Progress Skeleton */}
                          <Box
                            sx={{
                              position: "relative",
                              width: "160px",
                              height: "80px",
                              overflow: "hidden",
                              "&::after": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background:
                                  theme.palette.mode === "dark"
                                    ? "rgba(255, 255, 255, 0.1)"
                                    : "rgba(0, 0, 0, 0.1)",
                                borderRadius: "80px 80px 0 0",
                                animation: "pulse 1.5s ease-in-out infinite",
                                "@keyframes pulse": {
                                  "0%": { opacity: 0.3 },
                                  "50%": { opacity: 0.6 },
                                  "100%": { opacity: 0.3 },
                                },
                              },
                            }}
                          >
                            {/* Inner semicircle */}
                            <Box
                              sx={{
                                position: "absolute",
                                top: "10px",
                                left: "10px",
                                right: "10px",
                                bottom: "0",
                                background: theme.palette.background.paper,
                                borderRadius: "70px 70px 0 0",
                                animation: "pulse 1.5s ease-in-out infinite",
                                animationDelay: "0.2s",
                              }}
                            />
                            {/* Progress arc */}
                            <Box
                              sx={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                right: "0",
                                bottom: "0",
                                border: `20px solid ${
                                  theme.palette.mode === "dark"
                                    ? "rgba(255, 255, 255, 0.1)"
                                    : "rgba(0, 0, 0, 0.1)"
                                }`,
                                borderColor: `${
                                  theme.palette.mode === "dark"
                                    ? "rgba(255, 255, 255, 0.1)"
                                    : "rgba(0, 0, 0, 0.1)"
                                } transparent transparent transparent`,
                                borderRadius: "80px 80px 0 0",
                                animation: "pulse 1.5s ease-in-out infinite",
                                animationDelay: "0.4s",
                              }}
                            />
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Stack
                          spacing={2}
                          sx={{ height: "100%", justifyContent: "center", mt: 0 }}
                        >
                          {/* List items skeleton */}
                          {[1, 2, 3, 4].map((itemIndex) => (
                            <Box
                              key={itemIndex}
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <Skeleton
                                variant="text"
                                width="40%"
                                height={20}
                                sx={{ flexGrow: 1 }}
                              />
                              <Skeleton
                                variant="text"
                                width="30%"
                                height={20}
                                sx={{ ml: 1, mr: 6 }}
                              />
                            </Box>
                          ))}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Box>
      );
    }

    if (isOnlyCloudUser || isOnlyPremAssetUser) {
      return (
        <Box height="100%" sx={{ p: 0, m: 0 }}>
          <Paper
            elevation={0}
            sx={{
              p: 0,
              pt: 0,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              bgcolor:
                theme.palette.mode === "dark" ? "background.paper" : "white",
              borderRadius: "4px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                height: "32px",
                mt: 1,
                ml: 1,
              }}
            >
              <Skeleton variant="text" width={150} height={24} />
            </Box>
            <Divider sx={{ mt: 0, mb: 0 }} />
            <Grid
              container
              spacing={0}
              alignItems="stretch"
              sx={{ flexGrow: 1, mt: 0, mb: 0, py: 0 }}
            >
              <Grid item xs={12} md={12} sx={{ height: "100%", py: 0, display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    height: "auto",
                    minHeight: "180px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 0,
                    width: "100%",
                  }}
                >
                  <Grid container spacing={0} alignItems="center" sx={{ height: "100%", py: 0 }}>
                    <Grid item xs={12} lg={6}>
                      <Box
                        sx={{
                          width: "100%",
                          height: "160px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                          mt: 0,
                          mb: 0,
                          py: 0,
                          px: 0,
                        }}
                      >
                        {/* Semicircular Progress Skeleton */}
                        <Box
                          sx={{
                            position: "relative",
                            width: "160px",
                            height: "80px",
                            overflow: "hidden",
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background:
                                theme.palette.mode === "dark"
                                  ? "rgba(255, 255, 255, 0.1)"
                                  : "rgba(0, 0, 0, 0.1)",
                              borderRadius: "80px 80px 0 0",
                              animation: "pulse 1.5s ease-in-out infinite",
                              "@keyframes pulse": {
                                "0%": { opacity: 0.3 },
                                "50%": { opacity: 0.6 },
                                "100%": { opacity: 0.3 },
                              },
                            },
                          }}
                        >
                          <Box
                            sx={{
                              position: "absolute",
                              top: "10px",
                              left: "10px",
                              right: "10px",
                              bottom: "0",
                              background: theme.palette.background.paper,
                              borderRadius: "70px 70px 0 0",
                              animation: "pulse 1.5s ease-in-out infinite",
                              animationDelay: "0.2s",
                            }}
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              top: "0",
                              left: "0",
                              right: "0",
                              bottom: "0",
                              border: `20px solid ${
                                theme.palette.mode === "dark"
                                  ? "rgba(255, 255, 255, 0.1)"
                                  : "rgba(0, 0, 0, 0.1)"
                              }`,
                              borderColor: `${
                                theme.palette.mode === "dark"
                                  ? "rgba(255, 255, 255, 0.1)"
                                  : "rgba(0, 0, 0, 0.1)"
                              } transparent transparent transparent`,
                              borderRadius: "80px 80px 0 0",
                              animation: "pulse 1.5s ease-in-out infinite",
                              animationDelay: "0.4s",
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <Stack
                        spacing={2}
                        sx={{ height: "100%", justifyContent: "center", mt: 0 }}
                      >
                        {[1, 2, 3, 4].map((itemIndex) => (
                          <Box
                            key={itemIndex}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <Skeleton
                              variant="text"
                              width="40%"
                              height={20}
                              sx={{ flexGrow: 1 }}
                            />
                            <Skeleton
                              variant="text"
                              width="30%"
                              height={20}
                              sx={{ ml: 1, mr: 6 }}
                            />
                          </Box>
                        ))}
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      );
    }
  }

  return (
    <Box height="100%" sx={{ p: 0, m: 0 }}>
      <Paper
        sx={{
          p: 0,
          pt: 0,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          bgcolor: theme.palette.mode === "dark" ? "background.paper" : "white",
          borderRadius: "4px",
        }}
      >
        <Typography
          color="isDarkMode ? '#FCFCFD' : '#222222'"
          variant="body2"
          gutterBottom
          sx={{
            fontWeight: "550",
            fontSize: "14px",
            height: "32px",
            mt: 1,
            ml: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          Misconfiguration
        </Typography>
        <Divider sx={{ mt: 0, mb: 0 }} />
        <Grid
          container
          spacing={0}
          alignItems="stretch"
          sx={{ flexGrow: 1, mt: 0, mb: 0, py: 0 }}
        >
          {isBothCloudAndPremAssetUser ? (
            <>
              {cloudChartData != null && (
                <>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    key={cloudChartData.id}
                    sx={{ height: "auto" }}
                  >
                    <Box
                      sx={{
                        p: 1,
                        height: "100%",
                        position: "relative",
                        // borderLeft:
                        //   index === 1
                        //     ? `1px solid ${theme.palette.divider}`
                        //     : "none",
                      }}
                    >
                      <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        sx={{ height: "100%" }}
                      >
                        <Grid item xs={6}>
                          <Box
                            //ref={index === 0 ? chartContainerRef : undefined}
                            sx={{
                              width: "100%",
                              height: "220px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              position: "relative",
                            }}
                          >
                            {(() => {
                              // Check if data is available and chart is ready
                              // if (!data || !chartReady) {
                              //   return (
                              //     <Box
                              //       sx={{
                              //         width: 220,
                              //         height: 220,
                              //         display: "flex",
                              //         alignItems: "center",
                              //         justifyContent: "center",
                              //         border: "2px dashed #ccc",
                              //         borderRadius: "50%",
                              //       }}
                              //     >
                              //       <Skeleton variant="circular" width={180} height={180} />
                              //     </Box>
                              //   );
                              // }

                              const series = cloudChartData.breakdown.map(
                                (item) => parseFloat(item.percentage)
                              );
                              const allZero = series.every((val) => val === 0);
                              const chartSeries = allZero ? [1] : series;
                              const chartColors = allZero
                                ? ["#D3D3D3"]
                                : cloudChartData.breakdown.map(
                                    (item) => item.color
                                  );

                              return (
                                <>
                                  <ReactECharts
                                    key={`misconfig-chart-${cloudChartData.id}`} // Stable key to prevent unnecessary re-renders
                                    ref={chartRef2}
                                    className="no-drag clickable-area"
                                    option={{
                                      legend: { show: false },
                                      tooltip: { show: false },
                                      series: [
                                        {
                                          type: "pie",
                                          radius: ["60%", "90%"],
                                          avoidLabelOverlap: false,
                                          minAngle: 5,
                                          itemStyle: {
                                            borderRadius: 0,
                                            borderColor: "#fff",
                                            borderWidth: 0,
                                          },
                                          label: { show: false },
                                          emphasis: {
                                            label: {
                                              show: false,
                                              fontSize: 20,
                                              fontWeight: "bold",
                                            },
                                          },
                                          labelLine: { show: false },
                                          padAngle: 1,
                                          data: cloudChartData.breakdown.map(
                                            (item) => {
                                              const value = parseFloat(
                                                item.value
                                              );
                                              const label =
                                                item.label.toLowerCase();

                                              // Assign color based on value and label
                                              let color = "#D3D3D3"; // default grey
                                              if (value > 0) {
                                                color =
                                                  label === "critical"
                                                    ? "#A7000F"
                                                    : label === "high"
                                                    ? "#FF692E"
                                                    : label === "medium"
                                                    ? "#FAC515"
                                                    : label === "low"
                                                    ? "#3CCB7F"
                                                    : "#D3D3D3";
                                              }

                                              return {
                                                value,
                                                name: item.label,
                                                itemStyle: { color },
                                              };
                                            }
                                          ),
                                        },
                                      ],
                                    }}
                                    style={{
                                      height: 220,
                                      width: 220,
                                      cursor: 'pointer',
                                    }}
                                    onEvents={{
                                      click: (params: any) => {
                                        console.log(
                                          "Clicked on pie chart:",
                                          params
                                        );
                                        setSelectedModule(cloudChartData.title);
                                        setSelectedSeverity(params.name);
                                        setIsDrawerOpen(true);
                                      },
                                    }}
                                    notMerge={true}
                                    lazyUpdate={true}
                                  />

                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      pointerEvents: "none",
                                      width: "140px",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontWeight: 900,
                                        fontSize: "20px",
                                        color: isDarkMode ? "#fff" : "#222",
                                        lineHeight: 1,
                                        textAlign: "center",
                                      }}
                                    >
                                      {cloudChartData.gaugeValue}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: "13px",
                                        color: isDarkMode ? "#fff" : "#5B5B65",
                                        textTransform: "uppercase",
                                        letterSpacing: "2px",
                                        fontWeight: 700,
                                        mt: "2px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {cloudChartData.title}
                                    </Typography>
                                  </Box>
                                </>
                              );
                            })()}
                          </Box>
                        </Grid>

                        <Grid item xs={6}>
                          <Stack
                            spacing={1}
                            sx={{
                              height: "100%",
                              justifyContent: "center",
                              alignContent: "center",
                              mt: 0,
                            }}
                          >
                            {cloudChartData.breakdown.map((item) => (
                              <Box
                                key={item.label}
                                className="no-drag clickable-area"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setSelectedModule(cloudChartData.title);
                                  setSelectedSeverity(item.label);
                                  setIsDrawerOpen(true);
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    flexGrow: 1,
                                    fontWeight: "bold",
                                    color: "#6D738F",
                                  }}
                                >
                                  {item.label}:
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mr: 6,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: 900,
                                      fontSize: "12px",
                                      color:
                                        item.label === "Critical"
                                          ? "#A7000F"
                                          : item.label === "High"
                                          ? "#FF692E"
                                          : item.label === "Medium"
                                          ? "#FAC515"
                                          : item.label === "Low"
                                          ? "#3CCB7F"
                                          : theme.palette.text.secondary,
                                    }}
                                  >
                                    {item.value}
                                  </Typography>
                                </Box>
                              </Box>
                            ))}
                          </Stack>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </>
              )}
              <Divider orientation="vertical" flexItem />
              {onPremChartData != null && (
                <>
                  <Grid
                    item
                    xs={12}
                    md={5.9}
                    key={onPremChartData.id}
                    sx={{ height: "auto" }}
                  >
                    <Box
                      sx={{
                        p: 1,
                        height: "100%",
                        position: "relative",
                        // borderLeft:
                        //   index === 1
                        //     ? `1px solid ${theme.palette.divider}`
                        //     : "none",
                      }}
                    >
                      <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        sx={{ height: "100%" }}
                      >
                        <Grid item xs={6}>
                          <Box
                            //ref={index === 0 ? chartContainerRef : undefined}
                            sx={{
                              width: "100%",
                              height: "220px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              position: "relative",
                            }}
                          >
                            {(() => {
                              // Check if data is available and chart is ready
                              // if (!data || !chartReady) {
                              //   return (
                              //     <Box
                              //       sx={{
                              //         width: 220,
                              //         height: 220,
                              //         display: "flex",
                              //         alignItems: "center",
                              //         justifyContent: "center",
                              //         border: "2px dashed #ccc",
                              //         borderRadius: "50%",
                              //       }}
                              //     >
                              //       <Skeleton variant="circular" width={180} height={180} />
                              //     </Box>
                              //   );
                              // }

                              const series = onPremChartData.breakdown.map(
                                (item) => parseFloat(item.percentage)
                              );
                              const allZero = series.every((val) => val === 0);
                              const chartSeries = allZero ? [1] : series;
                              const chartColors = allZero
                                ? ["#D3D3D3"]
                                : onPremChartData.breakdown.map(
                                    (item) => item.color
                                  );

                              return (
                                <>
                                  <ReactECharts
                                    key={`misconfig-chart-${onPremChartData.id}`} // Stable key to prevent unnecessary re-renders
                                    ref={chartRef3}
                                    className="no-drag clickable-area"
                                    option={{
                                      legend: { show: false },
                                      tooltip: { show: false },
                                      series: [
                                        {
                                          type: "pie",
                                          radius: ["60%", "90%"],
                                          avoidLabelOverlap: false,
                                          minAngle: 5,
                                          itemStyle: {
                                            borderRadius: 0,
                                            borderColor: "#fff",
                                            borderWidth: 0,
                                          },
                                          label: { show: false },
                                          emphasis: {
                                            label: {
                                              show: false,
                                              fontSize: 20,
                                              fontWeight: "bold",
                                            },
                                          },
                                          labelLine: { show: false },
                                          padAngle: 1,
                                          data: onPremChartData.breakdown.map(
                                            (item) => {
                                              const value = parseFloat(
                                                item.value
                                              );
                                              const label =
                                                item.label.toLowerCase();

                                              // Assign color based on value and label
                                              let color = "#D3D3D3"; // default grey
                                              if (value > 0) {
                                                color =
                                                  label === "critical"
                                                    ? "#A7000F"
                                                    : label === "high"
                                                    ? "#FF692E"
                                                    : label === "medium"
                                                    ? "#FAC515"
                                                    : label === "low"
                                                    ? "#3CCB7F"
                                                    : "#D3D3D3";
                                              }

                                              return {
                                                value,
                                                name: item.label,
                                                itemStyle: { color },
                                              };
                                            }
                                          ),
                                        },
                                      ],
                                    }}
                                    style={{
                                      height: 220,
                                      width: 220,
                                      cursor: 'pointer',
                                    }}
                                    onEvents={{
                                      click: (params: any) => {
                                        console.log(
                                          "Clicked on pie chart:",
                                          params
                                        );
                                        setSelectedModule(
                                          onPremChartData.title
                                        );
                                        setSelectedSeverity(params.name);
                                        setIsDrawerOpen(true);
                                      },
                                    }}
                                    notMerge={true}
                                    lazyUpdate={true}
                                  />

                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      pointerEvents: "none",
                                      width: "140px",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontWeight: 900,
                                        fontSize: "20px",
                                        color: isDarkMode ? "#fff" : "#222",
                                        lineHeight: 1,
                                        textAlign: "center",
                                      }}
                                    >
                                      {onPremChartData.gaugeValue}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: "13px",
                                        color: isDarkMode ? "#fff" : "#5B5B65",
                                        textTransform: "uppercase",
                                        letterSpacing: "2px",
                                        fontWeight: 700,
                                        mt: "2px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {onPremChartData.title}
                                    </Typography>
                                  </Box>
                                </>
                              );
                            })()}
                          </Box>
                        </Grid>

                        <Grid item xs={6}>
                          <Stack
                            spacing={1}
                            sx={{
                              height: "100%",
                              justifyContent: "center",
                              alignContent: "center",
                              mt: 0,
                            }}
                          >
                            {onPremChartData.breakdown.map((item) => (
                              <Box
                                key={item.label}
                                className="no-drag clickable-area"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setSelectedModule(onPremChartData.title);
                                  setSelectedSeverity(item.label);
                                  setIsDrawerOpen(true);
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    flexGrow: 1,
                                    fontWeight: "bold",
                                    color: "#6D738F",
                                  }}
                                >
                                  {item.label}:
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mr: 6,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: 900,
                                      fontSize: "12px",
                                      color:
                                        item.label === "Critical"
                                          ? "#A7000F"
                                          : item.label === "High"
                                          ? "#FF692E"
                                          : item.label === "Medium"
                                          ? "#FAC515"
                                          : item.label === "Low"
                                          ? "#3CCB7F"
                                          : theme.palette.text.secondary,
                                    }}
                                  >
                                    {item.value}
                                  </Typography>
                                </Box>
                              </Box>
                            ))}
                          </Stack>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </>
              )}
            </>
            
          ) : (
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                height: "100%",
                py: 0,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  height: "auto",
                  minHeight: "180px",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 0,
                  width: "100%",
                }}
              >
                <Grid
                  container
                  spacing={0}
                  alignItems="center"
                  sx={{ height: "100%", py: 0 }}
                >
                  <Grid item xs={12} lg={6}>
                    <Box
                      ref={chartContainerRef}
                      sx={{
                        width: "100%",
                        height: "160px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        mt: 0,
                        mb: 0,
                        py: 0,
                        px: 0,
                      }}
                    >
                      {/* Chart */}
                      {(() => {
                        let data = null;
                        if (isOnlyCloudUser) {
                          data = cloudChartData;
                        } else if (isOnlyPremAssetUser) {
                          data = onPremChartData;
                        }
                        //data = chartData[0];

                        // Check if data is available and chart is ready
                        // if (!data || !chartReady) {
                        //   return (
                        //     <Box
                        //       sx={{
                        //         width: 220,
                        //         height: 220,
                        //         display: "flex",
                        //         alignItems: "center",
                        //         justifyContent: "center",
                        //         border: "2px dashed #ccc",
                        //         borderRadius: "50%",
                        //       }}
                        //     >
                        //       <Skeleton variant="circular" width={180} height={180} />
                        //     </Box>
                        //   );
                        // }

                        const series = data?.breakdown.map((item) =>
                          parseFloat(item.percentage)
                        );
                        const allZero = series?.every((val) => val === 0);
                        const chartSeries = allZero ? [1] : series;
                        const chartColors = allZero
                          ? ["#D3D3D3"]
                          : data?.breakdown.map((item) => item.color);

                        return (
                          <>
                            <ReactECharts
                              key={`misconfig-chart-${data?.id}`} // Stable key to prevent unnecessary re-renders
                              ref={chartRef1}
                              className="no-drag clickable-area"
                              option={{
                                legend: { show: false },
                                tooltip: { show: false },
                                series: [
                                  {
                                    type: "pie",
                                    radius: ["60%", "90%"],
                                    avoidLabelOverlap: false,
                                    minAngle: 5,
                                    itemStyle: {
                                      borderRadius: 0,
                                    },
                                    label: { show: false },
                                    emphasis: {
                                      label: {
                                        show: false,
                                        fontSize: 20,
                                        fontWeight: "bold",
                                      },
                                    },
                                    labelLine: { show: false },
                                    padAngle: 1,
                                    data: data?.breakdown.map((item) => {
                                      const value = parseFloat(item.value);
                                      const label = item.label.toLowerCase();

                                      // Assign color based on value and label
                                      let color = "#D3D3D3"; // default grey
                                      if (value > 0) {
                                        color =
                                          label === "critical"
                                            ? "#A7000F"
                                            : label === "high"
                                            ? "#FF692E"
                                            : label === "medium"
                                            ? "#FAC515"
                                            : label === "low"
                                            ? "#3CCB7F"
                                            : "#D3D3D3";
                                      }

                                      return {
                                        value,
                                        name: item.label,
                                        itemStyle: { color },
                                      };
                                    }),
                                  },
                                ],
                              }}
                              style={{
                                height: 160,
                                width: 160,
                                cursor: 'pointer',
                              }}
                              onEvents={{
                                click: (params: any) => {
                                  console.log("Clicked on pie chart:", params);
                                  setSelectedModule(data?.title ?? "");
                                  setSelectedSeverity(params.name);
                                  setIsDrawerOpen(true);
                                },
                              }}
                              notMerge={true}
                              lazyUpdate={true}
                            />

                            <Box
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                pointerEvents: "none",
                                width: "160px",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: 900,
                                  fontSize: "20px",
                                  color: isDarkMode ? "#fff" : "#222",
                                  lineHeight: 1,
                                  textAlign: "center",
                                }}
                              >
                                {data?.gaugeValue}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: isDarkMode ? "#fff" : "#5B5B65",
                                  textTransform: "uppercase",
                                  letterSpacing: "2px",
                                  fontWeight: 700,
                                  mt: "2px",
                                  textAlign: "center",
                                }}
                              >
                                {data?.title ?? ""}
                              </Typography>
                            </Box>
                          </>
                        );
                      })()}
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={6}
                    sx={{
                      ml: { xs: 5, lg: 0 },
                    }}
                  >
                    {" "}
                    <Stack
                      spacing={1}
                      sx={{
                        height: "100%",
                        justifyContent: "center",
                        alignContent: "center",
                        mt: 0,
                      }}
                    >
                      {cloudChartData?.breakdown.map((item) => (
                        <Box
                          key={item.label}
                          className="no-drag clickable-area"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setSelectedModule(cloudChartData?.title ?? "");
                            setSelectedSeverity(item.label);
                            setIsDrawerOpen(true);
                          }}
                        >
                          {/* <Box
                            component="img"
                            src={
                              {
                                Critical: Critical_Dashboard_img,
                                High: High_Dashboard_img,
                                Medium: Medium_Dashboard_img,
                                Low: Low_Dashboard_img,
                              }[item.label] || "/images/default.png"
                            }
                            alt={item.label}
                            sx={{
                              width: 18,
                              height: 18,
                              borderRadius: "50%",
                              mr: 1,
                            }}
                          /> */}
                          <Typography
                            variant="body2"
                            sx={{
                              flexGrow: 1,
                              fontWeight: "bold",
                              color: "#6D738F",
                            }}
                          >
                            {item.label}:
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mr: 6,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 900,
                                fontSize: "12px",
                                color:
                                  item.label === "Critical"
                                    ? "#A7000F"
                                    : item.label === "High"
                                    ? "#FF692E"
                                    : item.label === "Medium"
                                    ? "#FAC515"
                                    : item.label === "Low"
                                    ? "#3CCB7F"
                                    : theme.palette.text.secondary,
                              }}
                            >
                              {item.value}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                      {onPremChartData?.breakdown.map((item) => (
                        <Box
                          key={item.label}
                          className="no-drag clickable-area"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setSelectedModule(onPremChartData?.title ?? "");
                            setSelectedSeverity(item.label);
                            setIsDrawerOpen(true);
                          }}
                        >
                          {/* <Box
                            component="img"
                            src={
                              {
                                Critical: Critical_Dashboard_img,
                                High: High_Dashboard_img,
                                Medium: Medium_Dashboard_img,
                                Low: Low_Dashboard_img,
                              }[item.label] || "/images/default.png"
                            }
                            alt={item.label}
                            sx={{
                              width: 18,
                              height: 18,
                              borderRadius: "50%",
                              mr: 1,
                            }}
                          /> */}
                          <Typography
                            variant="body2"
                            sx={{
                              flexGrow: 1,
                              fontWeight: "bold",
                              color: "#6D738F",
                            }}
                          >
                            {item.label}:
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mr: 6,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 900,
                                fontSize: "12px",
                                color:
                                  item.label === "Critical"
                                    ? "#A7000F"
                                    : item.label === "High"
                                    ? "#FF692E"
                                    : item.label === "Medium"
                                    ? "#FAC515"
                                    : item.label === "Low"
                                    ? "#3CCB7F"
                                    : theme.palette.text.secondary,
                              }}
                            >
                              {item.value}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          )}
        </Grid>
      </Paper>
      <DrawerWrapper
        styles={{ width: "50%", padding: 0, margin: 0 }}
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        header={
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" fontWeight={700} fontSize="16px">
              {selectedModule} Security Posture
            </Typography>
            <LaunchSharpIcon
              sx={{ color: isDarkMode ? "white" : "black", cursor: "pointer" }}
              style={{ height: 22, cursor: "pointer" }}
              onClick={() => {
                if (selectedModule === "On-prem") {
                  navigate("/on-premises/security-posture");
                } else if (selectedModule === "Cloud") {
                  navigate("/cloud/security-posture");
                }
              }}
            />
          </Box>
        }
        body={
          <AgGridTable
            columnDefs={[
              {
                field: "param_name",
                headerName: "Recommendation",
                flex: 1,
                minWidth: 330,
                sortable: false,
                filter: false,
                cellRenderer: (params: any) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight="600"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          pt: 1,
                        }}
                        title={params.data.param_name}
                      >
                        {params.value}
                      </Typography>
                    </Box>
                  );
                },
              },
              {
                field: "highest_priority",
                headerName: "Severity",
                width: 150,
                cellRenderer: (params: any) => {
                  const severityStyles: any = {
                    Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  };
                  return (
                    <Chip
                      label={params.value}
                      size="small"
                      sx={{
                        bgcolor:
                          severityStyles[params.value]?.bgcolor || "#f5f5f5",
                        color: severityStyles[params.value]?.color || "#666666",
                        height: "20px",
                        borderRadius: "4px",
                        position: "relative",
                        fontWeight: 600,
                        p: 1.5,
                        pr: 0,
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          left: 8,
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: 8,
                          height: 8,
                          bgcolor:
                            severityStyles[params.value]?.color || "#666666",
                          borderRadius: "50%",
                        },
                        "& .MuiChip-label": { px: 1 },
                      }}
                    />
                  );
                },
              },
              {
                field: "accepted_count",
                headerName: "Risk Accepted",
                maxWidth: 150,
                    cellRenderer: (params: any) =>
        params.value > 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
            <img src={Exclamation} alt="exclamation" height="20" />
            <Typography>{params.value}</Typography>
          </Box>
        ) : (<img
          src={AcceptedRisk_False}
          alt="warning"
          style={{ height: "20px" }}
        />),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
              },
              {
                field: "asset_passed_percent",
                headerName:
                  selectedModule == "on_premise" ? "Assets" : "Resources",
                width: 200,
                cellRenderer: (params: any) => {
                  const passedCount = params.data.passed_asset_count;
                  const compliance_count = params.data.total_asset_count || 0;
                  const rawValue = params.value || 0;
                  const progressValue = Number(rawValue.toFixed(2));

                  return (
                    <Box sx={{ width: "100%" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 0.5,
                        }}
                      >
                        <Typography variant="caption">{`${passedCount}/${compliance_count} (${progressValue}%)`}</Typography>
                      </Box>
                      <LinearProgress
                        variant="determinate"
                        value={progressValue}
                        sx={{
                          height: 6,
                          borderRadius: 3,
                          bgcolor: "#f5f5f5",
                          "& .MuiLinearProgress-bar": {
                            bgcolor: "#4caf50",
                          },
                        }}
                      />
                    </Box>
                  );
                },
              },
            ]}
            showSearch={true}
            height={"calc(100vh - 83px)"}
            isLoading={isLoading}
            data={filteredRiskDetails}
            pagination={true}
            onRowClick={handleOnRowClick}
          />
        }
      />
      {isDetailsDrawerOpen && (
        <SecurityDetailsDrawer
          open={isDetailsDrawerOpen}
          onClose={() => setIsDetailsDrawerOpen(false)}
          row={selectedRow}
          module={selectedModule === "On-prem" ? "on_premise" : "cloud"}
          selectedRow={selectedRow}
          showBackButton={true}
        />
      )}
    </Box>
  );
};

export default Misconfiguration;
